export default "__VITE_ASSET__B_2cjEuC__"